import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { tagCloud } from "@/mocks/articles";
import { faqs } from "@/mocks/faqs";

export default function TagFaqSection() {
  return (
    <section aria-labelledby="tagfaq-heading" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <h2 id="tagfaq-heading" className="sr-only">
          热门标签与常见问题
        </h2>
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-5">
            <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">热门标签</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              这些是读者检索最多的关键词，点击可直接进入对应的话题存档。
            </p>
            <div className="mt-5 flex flex-wrap gap-2.5">
              {tagCloud.map((tag) => (
                <Link
                  key={tag}
                  to={`/archive?q=${encodeURIComponent(tag)}`}
                  className="rounded-full border border-background-300 bg-background-50 px-3.5 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
                >
                  #{tag}
                </Link>
              ))}
            </div>

            <div className="mt-8 grid grid-cols-3 gap-3">
              {[
                { value: "10+", label: "已归档话题" },
                { value: "6", label: "常设栏目" },
                { value: "每周", label: "盘点更新" },
              ].map((stat) => (
                <div key={stat.label} className="rounded-lg border border-background-200 bg-background-50 p-4 text-center">
                  <p className="font-heading text-xl font-bold text-primary-600">{stat.value}</p>
                  <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="flex items-end justify-between">
              <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">常见问题</h3>
              <Link to="/faq" className="text-sm font-medium text-primary-600 transition-colors hover:text-primary-700">
                全部问答 →
              </Link>
            </div>
            <div className="mt-5">
              <FaqAccordion items={faqs.slice(0, 5)} defaultOpen={0} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}